import { render } from "./vgoinmonad.vue?vue&type=template&id=00ab5bd3&scoped=true"
import script from "./vgoinmonad.vue?vue&type=script&lang=js"
export * from "./vgoinmonad.vue?vue&type=script&lang=js"

import "./vgoinmonad.vue?vue&type=style&index=0&id=00ab5bd3&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00ab5bd3"]])

export default __exports__